import './styles.scss'

import React from 'react'
import { useActions, useValues } from 'kea'

import Toggle from 'lib/forms/toggle'

import logic from './logic'

function isTranslatorAndWindowDefined () {
  if (typeof window === 'undefined') {
    return false
  }
  const body = window.document.getElementsByTagName('body')[0]
  return body && body.dataset.isTranslator === 'true'
}

export default function OfflineToggleMode () {
  const { offlineToggleMode } = useValues(logic)
  const { setOfflineToggleMode } = useActions(logic)

  const toggleOfflineMode = () => {
    setOfflineToggleMode()
  }

  if (!isTranslatorAndWindowDefined()) {
    return null
  }

  return (
    <div className='offline-toggle-mode'>
      <Toggle checked={offlineToggleMode} onClick={toggleOfflineMode} />
    </div>
  )
}
